export default __webpack_public_path__ + "static/knit1-41b5439693b17da011783864cd94b743.png";